
import { ProgressBar } from "./ProgressBar"
import { DataCard } from "./DataCard"
import { renderCurrentJob } from "../../utils/Candidate Portal/renderCurrentJob"
import { renderRecentCourse } from "../../utils/Candidate Portal/renderRecentCourse"
import { renderResumeFilename } from "../../utils/Candidate Portal/renderResumeFilename"
import { HiOutlineBriefcase } from "react-icons/hi2";
import { RiGraduationCapLine } from "react-icons/ri";
import { FaRegFileAlt } from "react-icons/fa";
import { useContext } from "react"
import { DataProvider } from "../../store/ContextProvider"

export function ProfileCard({ user }) {
    const { currentUser } = useContext(DataProvider)
    const formatNames = values =>
        values?.split(/[_-\s]/).map(v => v[0]?.toUpperCase() + v.slice(1)).join(' ');

    const renderProfileImage = (imgSrc, name) => {
        //BASE64 image detected → convert & return
        if (imgSrc && typeof imgSrc === "string" && imgSrc.length > 50) {
            let mimeType = "image/png";

            if (imgSrc.startsWith("/9j/")) mimeType = "image/jpeg";
            else if (imgSrc.startsWith("iVBOR")) mimeType = "image/png";
            else if (imgSrc.startsWith("R0lG")) mimeType = "image/gif";
            else if (imgSrc.startsWith("UklG")) mimeType = "image/webp";
            else if (imgSrc.startsWith("Qk")) mimeType = "image/bmp";

            return `data:${mimeType};base64,${imgSrc}`;
        }

        //Normal image URL exists
        if (imgSrc && imgSrc.trim() !== "") {
            return imgSrc;
        }

        //Last fallback → UI Avatar
        return `https://ui-avatars.com/api/?name=${encodeURIComponent(name || currentUser?.fullName)}&background=e8eaff&color=2c25c4`;
    };

    return (
        <div className='p-3'>

            <div className='flex gap-3 items-center p-3 bg-gradient-to-r from-purple-50 to-purple-200 rounded-xl shadow my-2'>
                <img
                    className="w-[80px] rounded-full aspect-square"
                    src={renderProfileImage(user?.profilePicLink || "", user?.applicantName || currentUser?.fullName || "")}
                    alt={user?.applicantName || currentUser?.fullName}
                />
                <div>{console.log("userprofile", user)}
                    <h5 className='font-medium text-lg cursor-pointer'>{user?.applicantName || user?.user?.fullName || currentUser?.fullName}</h5>
                    <h6>{user?.preferredJob?.length > 0 ? (formatNames(user?.preferredJob[0])) : "-"}</h6>
                </div>
            </div>

            <hr className='my-2 mx-2' />

            <div className='p-3 rounded-lg shadow bg-white'>
                <div className='flex gap-2 justify-between items-end'>
                    <h6 className='font-medium'>Profile Status</h6>
                    <span>{user?.score || 0}%</span>
                </div>
                <ProgressBar value={user?.score || 0} />
                <a className='text-primary-300 text-sm' href={`/update-account/skills?userId=${user?.user._id}`}>Tap here to Update profile</a>
            </div>

            {user && <DataCard Icon={HiOutlineBriefcase} title={"Current"} value={renderCurrentJob(user) || "-"} />}
            {user && <DataCard Icon={RiGraduationCapLine} title={"Recent Education"} value={renderRecentCourse(user) || "-"} />}
            {user && <DataCard Icon={FaRegFileAlt} title={"Resume"} value={renderResumeFilename(user) || "-"} resumeLink={true} />}

            {
                (user?.skills?.length > 0) &&
                <div className='p-3 rounded-lg shadow flex gap-3 items-center my-2 bg-white'>
                    <h6 className='font-medium'>Skills</h6>
                    <div className='flex flex-wrap gap-2 items-center my-2'>
                        {user.skills.map((skill, i) => {
                            if (i < 7) {
                                return <span className='bg-purple-100 text-secondary-300 px-3 rounded-xl text-sm' key={i}>{formatNames(skill.skill)}</span>
                            }
                            else return null;
                        })}
                        {
                            user.skills?.length > 7 && <span className='bg-slate-200 text-slate-700 px-3 rounded-xl text-sm'>& more</span>
                        }
                    </div>
                </div>
            }

        </div>
    )
}